<template>
  <div class="modal-backdrop">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header-info">
          <h5 class="modal-title">
            <span class="warning-icon">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                <path d="M27.6643 22.7715L16.2925 2.58448C15.3229 0.821449 12.6783 0.821449 11.7085 2.58448L0.336854 22.7715C-0.632802 24.5345 0.601333 26.7384 2.62884 26.7384H25.2842C27.3998 26.6503 28.6339 24.5345 27.6643 22.7715Z" fill="#FF0000"/>
                <path d="M14.0006 3.90674L25.3724 24.0938H2.62891L14.0006 3.90674Z" fill="white"/>
                <path d="M12.1494 13.1625L12.8546 17.8347C12.9428 18.3635 13.3835 18.8043 14.0006 18.8043C14.5295 18.8043 15.0585 18.3635 15.1466 17.8347L15.8518 13.1625C16.0281 12.0165 15.1466 11.0469 14.0006 11.0469C12.8546 11.0468 12.0612 12.0165 12.1494 13.1625Z" fill="#3F4448"/>
                <path d="M14.0005 21.8901C14.5847 21.8901 15.0583 21.4165 15.0583 20.8323C15.0583 20.248 14.5847 19.7744 14.0005 19.7744C13.4162 19.7744 12.9426 20.248 12.9426 20.8323C12.9426 21.4165 13.4162 21.8901 14.0005 21.8901Z" fill="#3F4448"/>
                </g>
                <defs>
                <clipPath id="clip0">
                <rect width="28" height="28" fill="white"/>
                </clipPath>
                </defs>
              </svg>
            </span>
            {{ $t('delete-dynamic-field') }}
          </h5>
          <button type="button" class="close" @click="this.close" aria-label="Close">
            <span aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path d="M16.5 1.4L15.1 0L8.5 6.6L1.9 0L0.5 1.4L7.1 8L0.5 14.6L1.9 16L8.5 9.4L15.1 16L16.5 14.6L9.9 8L16.5 1.4Z" fill="#7C7C7C"/>
              </svg>
            </span>
          </button>
        </div>
        <div class="modal-body-info">
          <p>{{ $t('delete-info-1') }} "{{ this.field.name }}" {{ $t('delete-info-2') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary cancel" @click="close">{{ $t('cancel') }}</button>
          <button type="button" class="btn btn-primary remove" @click="this.delete">{{ $t('confirm') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn{
  width: 190px;
  text-align: center;
}
.cancel{
  border: 1px solid #FF0000 !important;
  background: #F6F6F6 !important;
  color: #484848 !important;
}
.remove{
  background: #4CAF50 !important;
  color: #FFFFFF !important;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-body-info{
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 16px 16px 16px 35px;
  background: #ffffff;
}

.modal-body-info p{
  font-size: 14px;
}

.modal-footer {
  padding: 15px;
  display: flex;
  position: relative;
}
.modal-header-info {
  position: relative;
  border-bottom: 2px solid #F6F6F6;
  background: #ffffff;
  color: #000000;
  justify-content: space-between;
  display: flex;
  position: relative;
  padding: 15px 15px 15px 35px;
}
.modal-footer {
  border-top: 1px solid #eeeeee;
}
</style>

<script>
import axios from "axios";

export default {
  name: 'remove-dynamic-field-modal',
  props: ['field'],
  data: function(){
    return{
      data: this.field
    }
  },
  watch: {
    field: function(val){
      if(val){
        this.field = val;
      }
    },
  },
  methods: {
    delete: function(){
      this.isLoading = true;
      axios.post('deleteDynamicField', this.data).then(response => {
        var status = response.data.status;
        if (status) {
          this.$toast.success("Динамическое поле успешно удалено");
          this.$store.dispatch('fetchFields');
          this.close();
        }
      });
    },
    close: function() {
      this.$emit('close');
    },
  },
}
</script>